import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Button } from "react-bootstrap";


import { Error } from '../helpers/Error'
import { SpinnerGif } from '../helpers/SpinnerGif';
import './Imagenes.css'
import { globalContext } from '../Context/GlobalContext';
import { useTranslation } from 'react-i18next';

const apiProductos = process.env.REACT_APP_API_PRODUCTOS

const UltimosIngresos = () => {

    const [number, setNumber] = useState();
    const [current, setCurrent] = useState(0);
    const [isMobile, setIsMobile] = useState(false);
    const [titleVisible, setTitleVisible] = useState(false);
    const navigate = useNavigate();
    const { colorTheme } = useContext(globalContext)

    const [t] = useTranslation("global")

    // Detectar si es mobile
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        
        checkMobile();
        window.addEventListener('resize', checkMobile);
        
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Fade in del título
    useEffect(() => {
        const timer = setTimeout(() => {
            setTitleVisible(true);
        }, 300); // Delay de 300ms para el fade in
        
        return () => clearTimeout(timer);
    }, []);

    // Auto-scroll cada 5 segundos
    useEffect(() => {
        if (!number || number.length === 0) return;
        
        const autoScroll = setInterval(() => {
            goNext();
        }, 5000); // 5 segundos
        
        return () => clearInterval(autoScroll);
    }, [number, current]); // Dependencias para reiniciar cuando cambie

    useEffect(() => {
        obtenerDatos()
    }, []);

    const obtenerDatos = async () => {
        try {
            await axios(`${apiProductos}/ultimos_ingresos`)
                .then(res => { console.log(res); setNumber(res.data.articulos) })
                .catch(err => { console.log(err); })
        }
        catch (error) {
            console.log(error.message);
        }
    };

    let img = process.env.PUBLIC_URL + "/assets/sinimagen.gif";

    if (number === undefined) return <Error />

    if (!number) return <SpinnerGif text={'Cargando'} />

    const total = number.length;
    const itemsPerSlide = isMobile ? 1 : 4; // 1 en mobile, 4 en desktop
    const totalSlides = Math.ceil(total / itemsPerSlide);
    const currentSlide = Math.floor(current / itemsPerSlide);
    const goPrev = () => setCurrent((prev) => (prev - itemsPerSlide < 0 ? (totalSlides - 1) * itemsPerSlide : prev - itemsPerSlide));
    const goNext = () => setCurrent((prev) => (prev + itemsPerSlide >= total ? 0 : prev + itemsPerSlide));
    const goToSlide = (slideIndex) => setCurrent(slideIndex * itemsPerSlide); // Nueva función para ir a slide específico
    const slideItems = number.slice(currentSlide * itemsPerSlide, currentSlide * itemsPerSlide + itemsPerSlide);

    return (
        <div id="divUltimosIngresos" className={`bg-transparent text-${colorTheme === 'dark' ? 'light' : 'dark'} animated-title`}
            style={{ position: 'relative', maxWidth: 1400, margin: '0 auto', padding: '24px 24px 50px 24px' }}>
            <h2 style={{ 
                textAlign: 'center', 
                marginBottom: 24,
                fontSize: isMobile ? '32px' : '48px',
                margin: '0 0 36px',
                color: colorTheme === 'dark' ? '#ffffff' : '#515151',
                fontWeight: 700,
                letterSpacing: '0.04em',
                lineHeight: '1.15em',
                textTransform: 'uppercase',
                opacity: titleVisible ? 1 : 0,
                transform: titleVisible ? 'translateY(0px) scale(1)' : 'translateY(60px) scale(0.98)',
                transition: 'opacity 0.7s cubic-bezier(.4,2,.6,1), transform 0.7s cubic-bezier(.4,2,.6,1)'
            }}>{t("home.ultimos-ingresos")}</h2>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <button onClick={goPrev} style={{ background: 'none', border: 'none', fontSize: 40, cursor: 'pointer', color: '#888', padding: 0, marginRight: isMobile ? 8 : 16, lineHeight: 1 }}>&lt;</button>
                <div style={{ 
                    display: 'flex', 
                    gap: isMobile ? 0 : 36, 
                    justifyContent: 'center', 
                    width: '100%',
                    overflow: 'hidden' // Evitar scroll horizontal
                }}>
                    {slideItems.map((item, idx) => (
                        <div className={"renderItem text-dark animated-title"}
                            key={item.Alias}
                            style={{
                                minWidth: isMobile ? '90%' : 270,
                                maxWidth: isMobile ? '90%' : 320,
                                width: isMobile ? '90%' : 'auto',
                                background: colorTheme === 'dark' ? '#23272b' : '#fff',
                                borderRadius: 20,
                                boxShadow: '0 4px 18px 0 rgba(0,0,0,0.10)',
                                padding: 28,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                border: '1px solid #e0e0e0',
                                transition: 'box-shadow 0.2s',
                                animationDelay: `${idx * 0.12 + 0.1}s`,
                                margin: isMobile ? '0 auto' : '0'
                            }}>
                            <LazyLoadImage
                                src={item.Imagenes ? process.env.PUBLIC_URL + `/articulos/${encodeURIComponent(item.Imagenes?.split(',')[0])}` : img}
                                alt={'solution box'}
                                style={{
                                    width: '100%',
                                    maxWidth: 180,
                                    maxHeight: 140,
                                    minHeight: 80,
                                    objectFit: 'contain',
                                    borderRadius: 10,
                                    marginBottom: 18,
                                    background: '#f8f8f8',
                                    boxShadow: '0 1px 6px 0 rgba(0,0,0,0.08)',
                                    display: 'block',
                                }}
                            />
                            <div className='renderItemCenter' style={{ textAlign: 'center', marginBottom: 14 }}>
                                <div style={{
                                    fontWeight: 700,
                                    fontSize: 20,
                                    maxWidth: 220,
                                    margin: '0 auto',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical',
                                    minHeight: 48,
                                }}>{item.Nombre}</div>
                                <div style={{
                                    color: '#666',
                                    fontSize: 16,
                                    maxWidth: 220,
                                    margin: '0 auto',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical',
                                    minHeight: 40,
                                }}>{item.Marca}</div>
                            </div>
                            <Button variant="dark" className="btnItem" style={{ marginTop: 10, width: '100%', fontSize: 16, padding: '10px 0' }} onClick={() => navigate(`/detalle?sku=${item.Alias}`)}>{t("home.me-interesa")}</Button>
                        </div>
                    ))}
                </div>
                <button onClick={goNext} style={{ background: 'none', border: 'none', fontSize: 40, cursor: 'pointer', color: '#888', padding: 0, marginLeft: isMobile ? 8 : 16, lineHeight: 1 }}>&gt;</button>
            </div>
            <div style={{ textAlign: 'center', marginTop: 20, display: isMobile ? 'none' : 'block' }}>
                {Array.from({ length: totalSlides }).map((_, idx) => (
                    <span 
                        key={idx} 
                        onClick={() => goToSlide(idx)}
                        style={{
                            display: 'inline-block',
                            width: 12,
                            height: 12,
                            borderRadius: '50%',
                            background: idx === currentSlide ? '#333' : '#bbb',
                            margin: '0 4px',
                            transition: 'background 0.2s, transform 0.2s',
                            cursor: 'pointer',
                            transform: idx === currentSlide ? 'scale(1.2)' : 'scale(1)'
                        }} />
                ))}
            </div>
        </div>
    )
}
export default UltimosIngresos;
